import React, { useEffect, useState } from "react";
import { displayLegend, getLayerIds, getMrStaticLegend, MR_LAYER_ID } from '../../../utils/helpers/map/legendHelper';
import { v4 as uuidv4 } from 'uuid';
import HideLegend from "../Icon/hideLegend";
import ShowLegend from "../Icon/showLegend";

interface Props {
  type: string;
  option?: string;
}

const Legend = (props: Props) => {
  const storedValue = window.localStorage.getItem('legend');
  let stateData;

  if (storedValue !== null && storedValue !== 'undefined') {
    stateData = JSON.parse(storedValue);
  } else {
    stateData = [];
  }

  const [data] = useState(stateData);
  const [showLegend, SetShowLegend] = useState('none');
  const [legendToBuild, SetLegendToBuild] = useState<any[]>([]);

  // get layer legend thanks to ids
  const getLayersLegend = (pIds: number[]) => {
    let legendToShow: any[] = [];    
    pIds.forEach((id) => {      
      let res = data.find((layer: any) => id === layer.layerId);      
      if (res) {
        if (props.type === 'pr' && id === MR_LAYER_ID) {
          res = { ...res, legend: [...res.legend, ...getMrStaticLegend()] };
        }
        legendToShow.push(res);
      }
    });
    SetLegendToBuild(legendToShow);
  };

  // when type is changing we need to gets new layer ids (if type of data changed)
  useEffect(() => {
    if (data && data.length > 0) {
      const ids = getLayerIds(props.type, props.option);
      getLayersLegend(ids);
    }
  }, [props.type, data]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div
      id='test'
      style={{ position: 'absolute', right: '1vh', fontFamily: 'Montserrat' }}
    >
      {/* Button */}
      <button
        title='Légende'
        onClick={() => SetShowLegend(displayLegend(showLegend))}
      >
        {showLegend === 'block' ? <ShowLegend /> : <HideLegend />}
      </button>
      {/* Content of legend */}
      <div
        style={{
          backgroundColor: 'white',
          border: 'solid 1px',
          position: 'absolute',
          zIndex: 1,
          borderRadius: '5px',
          padding: '3px',
          display: showLegend,
        }}
      >
        {/* block */}
        {legendToBuild.map((layerContent: any) => {                    
          return (
            <div key={uuidv4()}>
              <div style={{ fontSize: '14px', fontWeight: 'bold' }}>
                {layerContent.layerName}
              </div>
              {/* Lines of a block */}
              {layerContent.legend.map((symbologyContent: any) => {
                return (
                  <div
                    key={uuidv4()}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      padding: '3px',
                    }}
                  >
                    <img
                      alt=''
                      src={
                        symbologyContent.svg
                          ? `data:image/svg+xml,${encodeURIComponent(symbologyContent.svg)}`
                          : `data:image/jpeg;base64,${symbologyContent.imageData}`
                      }
                      style={{ height: '25px', paddingRight: '3px' }}
                    />
                    <div style={{ whiteSpace: 'nowrap', fontSize: '11px' }}>
                      {symbologyContent.label}
                    </div>
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Legend;